(function () {
  "use strict";
  var ENDPOINT = "https://pixel-analytics.davescoffeepods.com/v1/events";
  var ROOT = "https://davescoffeepods.com";
  var KEY = "dave_pixel_v1";
  var SESSION_MS = 30 * 60 * 1000;

  function uuid() { return crypto.randomUUID ? crypto.randomUUID() : Date.now() + "-" + Math.random().toString(36).slice(2); }
  function read(name) { try { return JSON.parse(localStorage.getItem(name) || "null"); } catch (_) { return null; } }
  function write(name, value) { try { localStorage.setItem(name, JSON.stringify(value)); } catch (_) {} }
  function state() {
    var s = read(KEY) || {};
    var now = Date.now();
    if (!s.anonymous_id) s.anonymous_id = uuid();
    if (!s.session_id || now - (s.last_seen || 0) > SESSION_MS) s.session_id = uuid();
    s.last_seen = now;
    var q = new URLSearchParams(location.search);
    var next = {
      source: q.get("utm_source"), medium: q.get("utm_medium"), campaign: q.get("utm_campaign"),
      term: q.get("utm_term"), content: q.get("utm_content"),
      click_id: q.get("fbclid") || q.get("gclid") || q.get("msclkid")
    };
    if (Object.values(next).some(Boolean)) {
      if (!s.first_attribution) s.first_attribution = Object.assign({ landing_url: location.href }, next);
      s.attribution = Object.assign({ landing_url: location.href }, next);
    }
    write(KEY, s); return s;
  }
  function privacy() {
    try {
      var cp = window.Shopify && Shopify.customerPrivacy;
      return { analytics: !cp || typeof cp.analyticsProcessingAllowed !== "function" || cp.analyticsProcessingAllowed(), marketing: !!(cp && cp.marketingAllowed && cp.marketingAllowed()), sale_of_data: !!(cp && cp.saleOfDataAllowed && cp.saleOfDataAllowed()), source: "shopify" };
    } catch (_) { return { analytics: false, marketing: false, sale_of_data: false, source: "shopify_error" }; }
  }
  function transport(body) {
    var raw = JSON.stringify(body);
    if (navigator.sendBeacon) return navigator.sendBeacon(ENDPOINT, new Blob([raw], { type: "text/plain;charset=UTF-8" }));
    fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "text/plain;charset=UTF-8" }, body: raw, keepalive: true }).catch(function () {}); return true;
  }
  function send(eventName, data, force) {
    var s = state();
    if (!force && !privacy().analytics) return;
    var body = Object.assign({
      event_id: uuid(), event_name: eventName, occurred_at: new Date().toISOString(),
      anonymous_id: s.anonymous_id, session_id: s.session_id,
      page_url: location.href, referrer: document.referrer, attribution: s.attribution || s.first_attribution || {},
      identity: { browser_id: s.anonymous_id }
    }, data || {});
    transport(body);
  }
  function syncCartIdentity() {
    var s=state(), a=s.attribution||s.first_attribution||{}, attrs={ _dave_anonymous_id:s.anonymous_id, _dave_source:a.source||"", _dave_medium:a.medium||"", _dave_campaign:a.campaign||"", _dave_term:a.term||"", _dave_content:a.content||"", _dave_click_id:a.click_id||"" };
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/")+"cart/update.js", { method:"POST", credentials:"same-origin", headers:{"Content-Type":"application/json","Accept":"application/json"}, body:JSON.stringify({attributes:attrs}) }).catch(function(){});
  }
  function productMeta(variantId) {
    var p = (window.meta && window.meta.product) || (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product);
    if (!p) return null;
    var variants = p.variants || [];
    var wanted = String(variantId || new URLSearchParams(location.search).get("variant") || "");
    if (!wanted) {
      var picker = document.querySelector("form[action*='/cart/add'] [name='id']");
      wanted = picker ? String(picker.value || "") : "";
    }
    var selected = variants.find(function (v) { return String(v.id || "") === wanted; }) || variants[0] || {};
    return { id: String(p.id || ""), variant_id: String(selected.id || ""), name: p.title || document.title.replace(/\s*[|–-].*$/, ""), variant: selected.name || selected.title || "", quantity: 1, price: Number(selected.price || p.price || 0) / 100 };
  }
  function collectionName() {
    var match = location.pathname.match(/^\/collections\/([^/?]+)/); if (!match) return null;
    var heading = document.querySelector("main h1, .collection-hero__title, .collection-title");
    return (heading && heading.textContent.trim()) || decodeURIComponent(match[1]).replace(/-/g, " ");
  }
  var lastViewedVariant = "";
  function trackProductView(variantId) {
    var currentProduct = productMeta(variantId);
    if (!currentProduct || !currentProduct.variant_id || currentProduct.variant_id === lastViewedVariant) return;
    lastViewedVariant = currentProduct.variant_id;
    send("ViewContent", { currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "USD", value: currentProduct.price, products: [currentProduct], page_title: document.title });
  }
  function initPage() {
    send("PageView", { page_title: document.title, category: collectionName() });
    trackProductView();
    if (privacy().analytics) syncCartIdentity();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initPage, { once: true });
  else initPage();
  document.addEventListener("change", function (e) {
    var el = e.target;
    if (el && el.closest && el.closest("form[action*='/cart/add']") && (el.name === "id" || el.matches("select, input[type='radio']"))) {
      setTimeout(function () {
        var picker = document.querySelector("form[action*='/cart/add'] [name='id']");
        trackProductView(picker && picker.value);
      }, 0);
    }
  }, true);
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (form && /\/cart\/add/.test(form.action || "")) {
      var data = new FormData(form); var product = productMeta(data.get("id")) || {};
      product.quantity = Number(data.get("quantity") || 1);
      send("AddToCart", { currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "USD", value: Number(product.price || 0) * product.quantity, products: [product] });
    }
  }, true);
  document.addEventListener("click", function (e) {
    var el = e.target.closest && e.target.closest("a[href*='/checkout'],button[name='checkout'],input[name='checkout']");
    if (el) send("InitiateCheckout");
  }, true);
  var nativeFetch=window.fetch.bind(window);
  window.fetch=function(input,init){
    var url="";try{url=new URL(typeof input==="string"?input:input.url,location.origin).pathname}catch(_){}
    return nativeFetch(input,init).then(function(response){
      if(response.ok&&/\/cart\/(add|change|update)(\.js)?$/.test(url)){
        var clone=response.clone();clone.json().then(function(data){var items=data.items||[data];var products=items.map(function(line){return {id:String(line.product_id||""),variant_id:String(line.variant_id||line.id||""),name:line.product_title||line.title||"",variant:line.variant_title||"",quantity:Number(line.quantity||1),price:Number(line.final_price||line.price||0)/100};});send(url.indexOf("add")>=0?"AddToCart":"CartUpdated",{currency:window.Shopify&&Shopify.currency?Shopify.currency.active:"USD",value:Number(data.total_price||data.final_line_price||0)/100,products:products});syncCartIdentity();}).catch(function(){});
      }return response;
    });
  };
  var search=new URLSearchParams(location.search).get("q");if(location.pathname.indexOf("/search")===0&&search)send("Search",{query:search,page_title:document.title});
  document.addEventListener("visitorConsentCollected",function(){var p=privacy();send("ConsentUpdated",{consent:p},true);if(p.analytics){initPage();syncCartIdentity();}},{once:false});
  send("ConsentUpdated",{consent:privacy()},true);
  window.DavePixel = { track: send };
}());
